$(function () {
  /**
   * source: https://github.com/sitelint/accessible-gallery
   * example: see bottom of this file
   * This gallery is accessible and keyboard navigable and works fits the purpose well.
   * However there is one drawback. When clicking on a gallery thumbnail,
   * whether it's the one that opens the modal or the ones inside the modal,
   * the image replaces the entire page. To fix this the default behaviour of those links
   * must be disabled (preventDefaultLinks). To accomplish this for the modal which is added to/removed from the DOM
   * interactivley, a MutationObserver is used.
   **/

  /*
   * The gallery worked fine locally and on staging, but guess what...not on production!?
   * Those are the moment you curse being a developer. Anyways move on and hack the mainframe to get this out of the way.
   * Needs to be delivered today so no time to investigate further.
   * What happens on production is that the images are not displayed in the modal when clicking on the prev/next buttons or thumbnails.
   * My hack removed ythe dudd image and insters a new one with the actual src. I tell you, this is not the way to go.
   * But it works for now and I can deliver the project on time.
   */
  var hackTheMainframe = function () {
    var index = 0;
    var galleryImgContainer = document.querySelector(
      "#accessible_gallery_modal_inner_with_image"
    );
    var thumbs = document.querySelector(
      "#accessible_gallery_modal_inner_with_thumbnails"
    );
    var prevButton = document.querySelector(
      "#accessible_gallery_modal_previous_image"
    );
    var nextButton = document.querySelector(
      "#accessible_gallery_modal_next_image"
    );
    var thumbLinks = thumbs.querySelectorAll("a");

    var needsHack =
      thumbLinks[0].getAttribute("href").indexOf("data:image") > -1;

    if (!needsHack) {
      return;
    }

    var updateImg = function (src, alt) {
      var img = galleryImgContainer.querySelectorAll("img");

      if (img) {
        for (var i = 0; i < img.length; i++) {
          img[i].remove();
        }
      }

      img = document.createElement("img");
      img.setAttribute("id", "accessible_gallery_image");
      img.setAttribute("src", src);
      img.setAttribute("alt", alt || "");
      galleryImgContainer.appendChild(img);
    };

    var updateIndex = function (indx) {
      var max = thumbLinks.length - 1;
      index = parseInt(indx);
      if (index < 0) {
        index = max;
      } else if (index > max) {
        index = 0;
      }

      var thumbLink = document.querySelector("[data-index='" + index + "']");
      var thumbLinkImg = thumbLink.querySelector("img");
      if (thumbLink) {
        updateImg(
          thumbLink.getAttribute("href"),
          thumbLinkImg.getAttribute("alt")
        );
      }
    };

    var onThumbClick = function (e) {
      e.preventDefault();
      var indx = e.currentTarget.getAttribute("data-index");
      setTimeout(function () {
        updateIndex(indx);
      }, 100);
    };

    var onNext = function (e) {
      e.preventDefault();
      updateIndex(parseInt(index) + 1);
    };

    var onPrev = function (e) {
      e.preventDefault();
      updateIndex(parseInt(index) - 1);
    };

    for (var i = 0; i < thumbLinks.length; i++) {
      var link = thumbLinks[i];
      var linkImg = link.querySelector("img");
      var fullSizeSrc = linkImg.src.split("-150x150").join("");
      link.setAttribute("href", fullSizeSrc);
      link.setAttribute("data-index", i);

      if (i === index) {
        updateImg(fullSizeSrc);
      }

      link.removeEventListener("click", onThumbClick);

      link.addEventListener("click", onThumbClick);
    }

    prevButton.removeEventListener("click", onPrev);
    prevButton.addEventListener("click", onPrev);
    nextButton.removeEventListener("click", onNext);
    nextButton.addEventListener("click", onNext);
  };

  /* Initialize the gallery */

  const accessibleGallery = new window.accessible.gallery();
  accessibleGallery.init();

  window.gallery = accessibleGallery;

  /* Prevent default behaviour of gallery links */

  const preventDefaultLinks = (selector) => {
    var a = document.querySelectorAll(selector);
    a.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });
  };

  /* Prevent default behaviour of gallery links that are in the DOM at all times */

  preventDefaultLinks("[data-accessible-gallery-link]");

  /**
   * Observe the DOM to find out when the gallery modal has been added.
   * Then disable the default behaviour of gallery links inside the modal.
   * Otherwise the selected image will replace the entire page.
   *
   * source: https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
   **/

  if (document.querySelector("[data-accessible-gallery]")) {
    // Select the node that will be observed for mutations
    const targetNode = document.querySelector("body");

    // Options for the observer (which mutations to observe)
    const config = { childList: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          let galleryAdded = false;
          mutation.addedNodes.forEach((node) => {
            const isElementNode = node.nodeType === 1;
            if (
              isElementNode &&
              node.getAttribute("id") === "accessible_gallery_modal"
            ) {
              galleryAdded = true;
              preventDefaultLinks(
                ".accessible-gallery-modal__inner-container__thumbnails a"
              );
            }
          });

          if (galleryAdded) {
            document.querySelector("html").classList.add("gallery-modal-open");
            hackTheMainframe();
          } else {
            document
              .querySelector("html")
              .classList.remove("gallery-modal-open");
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }
});

/**
 * Example:
 * 
<ul class="accessible-gallery" data-accessible-gallery data-accessible-gallery-config='{"galleryTitle":"Gallery of images in a modal dialog","loadingMessage":"The image is being loaded","closeButtonMessage":"Close gallery", "previousImage":"Previous","nextImage":"Next", "closeButton":"Close dialog"}'>

    <li class="accessible-gallery__item" data-accessible-gallery-item>
        <a class="btn link link-dark" href="/wp-content/uploads/2024/07/Image-box-2.jpg" target="_blank" data-accessible-gallery-link>
            More details <i class="fa fa-angle-right" aria-hidden="true"></i>
            <img loading="lazy" alt="Image of a crashed red car" src="/wp-content/uploads/2024/07/Image-box-2-150x150.jpg" data-accessible-gallery-thumbnail="/wp-content/uploads/2024/07/Image-box-2-150x150.jpg">
        </a>
    </li>

    <li class="accessible-gallery__item" data-accessible-gallery-item style="display: none!important;">
        <a href="/wp-content/uploads/2024/07/Image-box-3.jpg" data-accessible-gallery-link>
        <img loading="lazy" alt="Image of a crashed yellow car" src="/wp-content/uploads/2024/07/Image-box-3-150x150.jpg" data-accessible-gallery-thumbnail="/wp-content/uploads/2024/07/Image-box-3-150x150.jpg">
        </a>
    </li>

</ul>
 */
